export const AVAILABLE_OBJECT_CLASSES = [
  'person',
  'bicycle',
  'car',
  'motorcycle',
  'airplane',
  'bus',
  'train',
  'truck',
  'boat',
  'traffic light',
  'fire hydrant',
  'stop sign',
  'parking meter',
  'bench',
  'bird',
  'cat',
  'dog',
  'horse',
  'sheep',
  'cow',
  'elephant',
  'bear',
  'zebra',
  'giraffe',
  'backpack',
  'umbrella',
  'handbag',
  'tie',
  'suitcase',
  'frisbee',
  'skis',
  'snowboard',
  'sports ball',
  'kite',
  'baseball bat',
  'baseball glove',
  'skateboard',
  'surfboard',
  'tennis racket',
  'bottle',
  'wine glass',
  'cup',
  'fork',
  'knife',
  'spoon',
  'bowl',
  'banana',
  'apple',
  'sandwich',
  'orange',
  'broccoli',
  'carrot',
  'hot dog',
  'pizza',
  'donut',
  'cake',
  'chair',
  'couch',
  'potted plant',
  'bed',
  'dining table',
  'toilet',
  'tv',
  'laptop',
  'mouse',
  'remote',
  'keyboard',
  'cell phone',
  'microwave',
  'oven',
  'toaster',
  'sink',
  'refrigerator',
  'book',
  'clock',
  'vase',
  'scissors',
  'teddy bear',
  'hair drier',
  'toothbrush'
];

export const DEFAULT_SELECTED_OBJECTS = AVAILABLE_OBJECT_CLASSES;
const STORAGE_KEY = 'object-detection:selected-objects';

function sanitizeSelectedObjects(selectedObjects) {
  if (!Array.isArray(selectedObjects)) {
    return DEFAULT_SELECTED_OBJECTS;
  }

  const normalizedSelections = [
    ...new Set(
      selectedObjects
        .map((item) => String(item).trim().toLowerCase())
        .filter((item) => AVAILABLE_OBJECT_CLASSES.includes(item))
    )
  ];

  return normalizedSelections.length > 0 ? normalizedSelections : DEFAULT_SELECTED_OBJECTS;
}

export function getSelectedObjects() {
  try {
    const rawValue = window.localStorage.getItem(STORAGE_KEY);
    if (!rawValue) {
      return DEFAULT_SELECTED_OBJECTS;
    }

    return sanitizeSelectedObjects(JSON.parse(rawValue));
  } catch (error) {
    console.error('Failed to read detection settings:', error);
    return DEFAULT_SELECTED_OBJECTS;
  }
}

export function saveSelectedObjects(selectedObjects) {
  const valueToStore = sanitizeSelectedObjects(selectedObjects);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(valueToStore));
  return valueToStore;
}
